export type RunState =
  | { type: 'empty' }
  | { type: 'starting'; abort: AbortController }
  | {
      type: 'running';
      abort?: AbortController;
      runId?: string;
    }
  | { type: 'halted' }
  | { type: 'completed' }
  | { type: 'error'; error: unknown };

export type RunStop =
  | { type: 'halted'; runId: string }
  | { type: 'completed'; runId: string }
  | { type: 'error'; error: unknown };

export const hasActiveRunId = (runState: RunState): boolean => {
  switch (runState.type) {
    case 'running':
    case 'halted':
      return true;
    case 'completed':
    case 'starting':
    case 'error':
    case 'empty':
      return false;
  }
};

export const isRunExecuting = (runState: RunState): boolean => {
  switch (runState.type) {
    case 'starting':
    case 'running':
      return true;
    case 'completed':
    case 'halted':
    case 'error':
    case 'empty':
      return false;
  }
};

export const canAbort = (
  runState: RunState
): runState is RunState & { abort: AbortController } => {
  switch (runState.type) {
    case 'starting':
    case 'running':
      return true;
    case 'completed':
    case 'halted':
    case 'error':
    case 'empty':
      return false;
  }
};

export const abortRun = (runState: RunState): void => {
  switch (runState.type) {
    case 'starting':
    case 'running':
      runState.abort?.abort();
      break;
    case 'completed':
    case 'halted':
    case 'error':
    case 'empty':
      break;
  }
};
